import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Task } from '@contracts/interfaces/task.interface';
import { TaskService } from '../../services/task.service';

@Component({
  selector: 'ap-snooze-dialog',
  templateUrl: 'snooze.dialog.html',
  styleUrls: ['./snooze.dialog.scss']
})
export class SnoozeDialogComponent {

  public task: Task;
  public active: string | null = null;
  public snoozeComment: string = '';

  public snoozeTill: Date = new Date();
  public readonly quickOptions = [
    { label: '10 seconds', seconds: 10, key: 'quick-10s' },
    { label: 'In 1 day', seconds: 86400, key: 'quick-1d' },
    { label: 'In 3 days', seconds: 86400 * 3, key: 'quick-3d' },
    { label: 'In 1 week', seconds: 604800, key: 'quick-1w' },
    { label: 'In 1 month', seconds: 2592000, key: 'quick-1m' },
  ];
  public readonly dayOptions = Array.from({ length: 30 }, (_, i) => i + 1);
  public readonly weekOptions = [1, 2, 3, 4];
  public readonly monthOptions = [1, 2, 3, 4, 5, 6];

  public readonly secondsPerDay = 86400;
  public readonly secondsPerWeek = 604800;
  public readonly secondsPerMonth = 2592000;

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<SnoozeDialogComponent>,
      public dialog: MatDialog,
      public taskService: TaskService) {
        this.task = data.task;
        if (this.task?.snooze?.until) {
          this.snoozeTill = new Date(this.task.snooze.until);
        }
      }

      selectChange(value: number, active: string | null) {
        this.active = active;

        this.snoozeTill = new Date(Date.now() + (value * 1000));
      }

      save() {
        this.task.snooze = {
            until: this.snoozeTill,
            comment: this.snoozeComment
        }

        this.taskService.update(this.task).subscribe(r => {
            this.dialogRef.close();
        })
      }
}
